import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import ImageListItemBar from "@material-ui/core/ImageListItemBar";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    width: "100%",
    height: 450,
  },
  imageListItem: {
    cursor: 'pointer',
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },
}));

const PhotoGrid = ({ photos, openLightbox }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ImageList rowHeight={160} className={classes.imageList} cols={3}>
        {photos.map((image, index) => (
          <ImageListItem key={image.img} className={classes.imageListItem}>
            <img
              src={`/mop/images/${image.img}`}
              alt={image.title}
              onClick={(e) => openLightbox(e, index)}
              loading="lazy"
            />
            {/* <ImageListItemBar title={image.title} /> */}
          </ImageListItem>
        ))}
      </ImageList>
    </div>
  );
};

export default PhotoGrid;